import { IconButton, Tooltip } from "@mui/material";
import { LuUpload } from "react-icons/lu";

const LoadEnvFactorButton = ({ label = "Load Environmental Factors", onClick = () => {}, disabled = false }) => {
  return (
    <Tooltip title={label}>
      <span>
        <IconButton
          onClick={onClick}
          disabled={disabled}
          sx={{
            backgroundColor: "rgba(22, 163, 74, 0.2)",
            "&:hover": { color: "white", backgroundColor: "rgba(22, 163, 74, 0.9)" },
            borderRadius: 2,
          }}>
          <LuUpload />
        </IconButton>
      </span>
    </Tooltip>
  );
};
export default LoadEnvFactorButton;
